import { GET_TTD_SEGMENT_REMODEL_CONFIGURATION } from '../queries';
import { useQuery } from '@apollo/client';

/**
 * Custom hook to fetch TTD segment remodel configuration
 * @param {Object} params - Hook parameters
 * @param {string} params.segmentId - The segment ID
 * @returns {Object} { loading, error, config, refetch }
 */
const useSegmentRemodelConfig = ({ segmentId }) => {
  const { loading, error, data, refetch } = useQuery(
    GET_TTD_SEGMENT_REMODEL_CONFIGURATION,
    {
      variables: { segmentId },
      skip: !segmentId,
      fetchPolicy: 'cache-and-network',
    }
  );

  const config = data?.getTtdSegmentRemodelConfiguration || null;

  return {
    loading,
    error,
    config,
    refetch,
  };
};

export default useSegmentRemodelConfig;
